// @docs https://[domain]/api/v1/docs#/PYR%2FEmployee%20Work%20Accidents
export default {
  List: "/pyr/employee-work-accidents",
  Create: "/pyr/employee-work-accidents",
  Detail: "/pyr/employee-work-accidents/{id}",
  Update: "/pyr/employee-work-accidents/{id}",
  Delete: "/pyr/employee-work-accidents/{id}",
};
